import { useTranslate } from "ra-core";
import { Badge } from "@/components/ui/badge";

import type { Partner } from "../types";
import { findTypeLabel, usePartnerTypes } from "./partnerTypes";

/** Category badge (Staff / Partenaire) followed by the partner's type. */
export const PartnerKind = ({
  partner,
}: {
  partner: Pick<Partner, "category" | "type">;
}) => {
  const translate = useTranslate();
  const types = usePartnerTypes(partner.category);
  return (
    <span className="inline-flex items-center gap-2 min-w-0">
      <Badge
        variant={partner.category === "staff" ? "secondary" : "outline"}
        className="font-normal shrink-0"
      >
        {translate(`resources.partners.categories.${partner.category}`)}
      </Badge>
      {partner.type ? (
        <span className="truncate text-sm">
          {findTypeLabel(types, partner.type)}
        </span>
      ) : null}
    </span>
  );
};
